import * as S from "./StepBar.style";
import { ReactComponent as SuccessIcon } from "assets/icons/success-icon.svg";
const steps = ["Quantidade de títulos", "Resumo", "Dados Pessoais", "Pagamento"];

const StepBar = ({ currentStep }) => {
  const totalSteps = steps.length;
  return (
    currentStep && (
      <nav aria-label="Breadcrumb">
        <S.StepBar>
          <S.StepBarContainer>
            {steps.map((stepName, index) => {
              const stepNumber = index + 1;
              const selected = stepNumber === currentStep;
              const pastStep = currentStep > stepNumber;
              return (
                <S.StepContainer key={`step ${stepNumber}`}>
                  <S.StepBox selected={selected} pastStep={pastStep}>
                    {pastStep ? <SuccessIcon /> : stepNumber}
                  </S.StepBox>
                  {selected && <S.StepText>{stepName}</S.StepText>}
                </S.StepContainer>
              );
            })}
          </S.StepBarContainer>
          <S.StyledProgressBar value={(currentStep * 100) / totalSteps} />
        </S.StepBar>
      </nav>
    )
  );
};

export default StepBar;
